import React, { useEffect, useMemo, useState } from "react";
import { api, thumbUrl } from "@/lib/apiClient";

// Toolost-style 3D rotating album cover gallery — pure CSS perspective ring.
// Each cover sits on a face of a vertical cylinder; the cylinder rotates slowly.
// Hover the gallery to pause and tilt for an interactive feel.

const DEFAULT_COVERS = [
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/h40xtrgv_White%20Dynamic%20Portrait%20Album%20Cover.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/uvilxy7y_Screenshot%202026-06-27%20143208.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/3j5yzark_Screenshot%202026-06-27%20143152.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/nbva2v2u_image_2026-06-27_144218900.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/nh90acau_10-SaadisPC.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/zimpvvl5_Screenshot%202026-06-27%20143309.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/qhb4uszu_Screenshot%202026-06-27%20143330.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/d1erwwze_Screenshot%202026-06-27%20143230.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/fd3fhag6_Screenshot%202026-06-27%20143343.png",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/dvpwzu8k_X%20%2812%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/qdj35rdj_artwork%20%284%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/caoupeqm_artwork%20%283%29.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/6ib9170e_21.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/ild89rx6_.%20%287%29.jpg.jpg",
  "https://customer-assets.emergentagent.com/job_melodist-dash/artifacts/dfyslt33_artwork%20%285%29.jpg",
];

export default function AlbumCoverRing({ size = 480 }) {
  const [customCovers, setCustomCovers] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/site/settings");
        if (data && Array.isArray(data.album_cover_urls) && data.album_cover_urls.length >= 4) {
          setCustomCovers(data.album_cover_urls.filter(Boolean));
        }
      } catch {}
    })();
  }, []);

  const items = useMemo(() => customCovers || DEFAULT_COVERS, [customCovers]);
  // Bigger faces (44%) + slightly wider ring → larger covers with the same small visible gap.
  const radius = Math.round(size * 1.15);
  const angle = 360 / items.length;

  return (
    <div className="album-ring-wrap" style={{ width: size, height: size }} data-testid="album-cover-ring" data-nosnippet aria-hidden="true">
      <div className="album-ring-stage">
        <div className="album-ring" style={{ "--radius": `${radius}px` }}>
          {items.map((src, i) => (
            <div
              key={i}
              className="album-face"
              style={{
                transform: `rotateY(${i * angle}deg) translateZ(${radius}px)`,
              }}
            >
              <div className="album-face-img" style={{ backgroundImage: `url("${thumbUrl(src, 480)}")` }} role="presentation" />
              <div className="album-shine" />
            </div>
          ))}
        </div>
      </div>
      <div className="album-ring-glow" aria-hidden="true" />
    </div>
  );
}
